module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-col', {
    staticClass: "mb-3",
    attrs: {
      "md": "12"
    }
  }, [_c('b-card', {
    staticClass: "formCardDash"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h6', {
    staticClass: "card-title mb-0"
  }, [_vm._v("Expense Management")]), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Total Expense Amount: " + _vm._s(_vm.formatCurrency(_vm.totalExpenseAmount)) + " | Total Records: " + _vm._s(_vm.totalRecords))])]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('b-row', {
    staticClass: "mb-3"
  }, [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "Search by invoice no, seller, buyer...",
      "size": "sm"
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.searchQuery),
      callback: function($$v) {
        _vm.searchQuery = $$v
      },
      expression: "searchQuery"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": [10, 25, 50, 100],
      "size": "sm"
    },
    on: {
      "change": _vm.updatePagination
    },
    model: {
      value: (_vm.perPage),
      callback: function($$v) {
        _vm.perPage = $$v
      },
      expression: "perPage"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "outline-info",
      "size": "sm",
      "disabled": _vm.isLoading
    },
    on: {
      "click": _vm.refreshData
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    class: {
      'fa-spin': _vm.isLoading
    }
  }), _vm._v("\n            Refresh\n          ")])], 1)], 1), _vm._v(" "), _c('b-table', {
    staticClass: "mb-0",
    attrs: {
      "items": _vm.expenseData,
      "fields": _vm.fields,
      "busy": _vm.isLoading,
      "striped": "",
      "bordered": "",
      "hover": "",
      "small": "",
      "show-empty": "",
      "empty-text": "No expense data found"
    },
    scopedSlots: _vm._u([{
      key: "invoiceNo",
      fn: function(data) {
        return [_c('code', [_vm._v(_vm._s(data.value))])]
      }
    }, {
      key: "date",
      fn: function(data) {
        return [_vm._v("\n          " + _vm._s(_vm.formatDate(data.value)) + "\n        ")]
      }
    }, {
      key: "category",
      fn: function(data) {
        return [_c('b-badge', {
          attrs: {
            "variant": "secondary"
          }
        }, [_vm._v(_vm._s(data.value))])]
      }
    }, {
      key: "sellerName",
      fn: function(data) {
        return [_c('strong', [_vm._v(_vm._s(data.value))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('small', {
          staticClass: "text-muted"
        }, [_vm._v(_vm._s(data.item.sellerTradeName))])]
      }
    }, {
      key: "buyerName",
      fn: function(data) {
        return [_c('strong', [_vm._v(_vm._s(data.value))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('small', {
          staticClass: "text-muted"
        }, [_vm._v(_vm._s(data.item.buyerTradeName))])]
      }
    }, {
      key: "amount",
      fn: function(data) {
        return [_c('strong', {
          staticClass: "text-right d-block"
        }, [_vm._v(_vm._s(_vm.formatCurrency(data.value)))])]
      }
    }, {
      key: "status",
      fn: function(data) {
        return [_c('b-badge', {
          attrs: {
            "variant": data.value === 'Active' ? 'success' : 'danger'
          }
        }, [_vm._v("\n            " + _vm._s(data.value) + "\n          ")])]
      }
    }, {
      key: "items",
      fn: function(data) {
        return [_c('b-badge', {
          attrs: {
            "variant": "primary"
          }
        }, [_vm._v(_vm._s(data.value.length || 0))])]
      }
    }, {
      key: "jobDetails.JobNo",
      fn: function(data) {
        return [(data.value) ? _c('code', [_vm._v(_vm._s(data.value))]) : _c('span', {
          staticClass: "text-muted"
        }, [_vm._v("N/A")])]
      }
    }, {
      key: "actions",
      fn: function(data) {
        return [_c('b-button', {
          staticClass: "toggle-btn",
          attrs: {
            "size": "sm",
            "variant": "outline-info"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.toggleDetails(data.item)
            }
          }
        }, [_c('i', {
          class: data.item._showDetails ? 'fa fa-chevron-up' : 'fa fa-chevron-down'
        })])]
      }
    }, {
      key: "row-details",
      fn: function(row) {
        return [_c('div', {
          staticClass: "row-details"
        }, [_c('div', {
          staticClass: "row mb-3"
        }, [_c('div', {
          staticClass: "col-12"
        }, [_c('div', {
          staticClass: "card border-primary"
        }, [_c('div', {
          staticClass: "card-header bg-primary text-white"
        }, [_c('i', {
          staticClass: "fa fa-info-circle"
        }), _vm._v(" Expense Details\n                  ")]), _vm._v(" "), _c('div', {
          staticClass: "card-body"
        }, [_c('div', {
          staticClass: "row"
        }, [_c('div', {
          staticClass: "col-md-3"
        }, [_c('strong', [_vm._v("Expense ID:")]), _vm._v(" " + _vm._s(row.item.expenseId) + "\n                      ")]), _vm._v(" "), _c('div', {
          staticClass: "col-md-3"
        }, [_c('strong', [_vm._v("Invoice No:")]), _vm._v(" " + _vm._s(row.item.invoiceNo) + "\n                      ")]), _vm._v(" "), _c('div', {
          staticClass: "col-md-3"
        }, [_c('strong', [_vm._v("Category:")]), _vm._v(" " + _vm._s(row.item.category) + "\n                      ")]), _vm._v(" "), _c('div', {
          staticClass: "col-md-3"
        }, [_c('strong', [_vm._v("Status:")]), _vm._v(" "), _c('b-badge', {
          staticClass: "ml-2",
          attrs: {
            "variant": row.item.status === 'Active' ? 'success' : 'danger'
          }
        }, [_vm._v("\n                          " + _vm._s(row.item.status) + "\n                        ")])], 1)]), _vm._v(" "), _c('div', {
          staticClass: "row mt-2"
        }, [_c('div', {
          staticClass: "col-md-12"
        }, [_c('strong', [_vm._v("Description:")]), _vm._v(" " + _vm._s(row.item.description) + "\n                      ")])])])])])]), _vm._v(" "), (row.item.jobDetails) ? _c('div', {
          staticClass: "row mb-3"
        }, [_c('div', {
          staticClass: "col-12"
        }, [_c('div', {
          staticClass: "card border-success"
        }, [_c('div', {
          staticClass: "card-header bg-success text-white"
        }, [_c('i', {
          staticClass: "fa fa-briefcase"
        }), _vm._v(" Job Details\n                  ")]), _vm._v(" "), _c('div', {
          staticClass: "card-body"
        }, [_c('div', {
          staticClass: "row"
        }, [_c('div', {
          staticClass: "col-md-3"
        }, [_c('strong', [_vm._v("Job No:")]), _vm._v(" " + _vm._s(row.item.jobDetails.JobNo) + "\n                      ")]), _vm._v(" "), _c('div', {
          staticClass: "col-md-3"
        }, [_c('strong', [_vm._v("Job Date:")]), _vm._v(" " + _vm._s(_vm.formatDate(row.item.jobDetails.JobDate)) + "\n                      ")]), _vm._v(" "), _c('div', {
          staticClass: "col-md-3"
        }, [_c('strong', [_vm._v("Job Type:")]), _vm._v(" " + _vm._s(row.item.jobDetails.JobType) + "\n                      ")]), _vm._v(" "), _c('div', {
          staticClass: "col-md-3"
        }, [_c('strong', [_vm._v("Transport Type:")]), _vm._v(" " + _vm._s(row.item.jobDetails.JobTransportType) + "\n                      ")])]), _vm._v(" "), _c('div', {
          staticClass: "row mt-2"
        }, [_c('div', {
          staticClass: "col-md-3"
        }, [_c('strong', [_vm._v("Client:")]), _vm._v(" " + _vm._s(row.item.jobDetails.ClientName) + "\n                      ")]), _vm._v(" "), _c('div', {
          staticClass: "col-md-3"
        }, [_c('strong', [_vm._v("Shipping Line:")]), _vm._v(" " + _vm._s(row.item.jobDetails.SlineName) + "\n                      ")]), _vm._v(" "), _c('div', {
          staticClass: "col-md-3"
        }, [_c('strong', [_vm._v("Raised By:")]), _vm._v(" " + _vm._s(row.item.jobDetails.RaisedBy) + "\n                      ")]), _vm._v(" "), _c('div', {
          staticClass: "col-md-3"
        }, [_c('strong', [_vm._v("Raised From:")]), _vm._v(" " + _vm._s(row.item.jobDetails.RaisedFrom) + "\n                      ")])]), _vm._v(" "), _c('div', {
          staticClass: "row mt-2"
        }, [_c('div', {
          staticClass: "col-md-3"
        }, [_c('strong', [_vm._v("POL → POD:")]), _vm._v(" " + _vm._s(row.item.jobDetails.POL) + " → " + _vm._s(row.item.jobDetails.POD) + "\n                      ")]), _vm._v(" "), _c('div', {
          staticClass: "col-md-3"
        }, [_c('strong', [_vm._v("Container Type:")]), _vm._v(" " + _vm._s(row.item.jobDetails.JobContainerType) + "\n                      ")]), _vm._v(" "), _c('div', {
          staticClass: "col-md-3"
        }, [_c('strong', [_vm._v("Enquiry:")]), _vm._v(" " + _vm._s(row.item.jobDetails.EnqNo) + "\n                      ")]), _vm._v(" "), _c('div', {
          staticClass: "col-md-3"
        }, [_c('strong', [_vm._v("SOB:")]), _vm._v(" " + _vm._s(row.item.jobDetails.SOB) + "\n                      ")])])])])])]) : _vm._e(), _vm._v(" "), (row.item.items && row.item.items.length > 0) ? _c('div', {
          staticClass: "row mb-3"
        }, [_c('div', {
          staticClass: "col-12"
        }, [_c('div', {
          staticClass: "card border-danger"
        }, [_c('div', {
          staticClass: "card-header bg-danger text-white"
        }, [_c('i', {
          staticClass: "fa fa-list"
        }), _vm._v(" Expense Items (" + _vm._s(row.item.items.length) + ")\n                  ")]), _vm._v(" "), _c('div', {
          staticClass: "card-body p-0"
        }, [_c('b-table', {
          staticClass: "mb-0",
          attrs: {
            "items": row.item.items,
            "fields": _vm.itemFields,
            "small": "",
            "bordered": ""
          },
          scopedSlots: _vm._u([{
            key: "amount",
            fn: function(data) {
              return [_vm._v("\n                        " + _vm._s(_vm.formatCurrency(data.value)) + "\n                      ")]
            }
          }])
        })], 1)])])]) : _vm._e(), _vm._v(" "), (row.item.modules && row.item.modules.length > 0) ? _c('div', {
          staticClass: "row mb-3"
        }, [_c('div', {
          staticClass: "col-12"
        }, [_c('div', {
          staticClass: "card border-info"
        }, [_c('div', {
          staticClass: "card-header bg-info text-white"
        }, [_c('i', {
          staticClass: "fa fa-cubes"
        }), _vm._v(" Modules (" + _vm._s(row.item.modules.length) + ")\n                  ")]), _vm._v(" "), _c('div', {
          staticClass: "card-body p-0"
        }, [_c('b-table', {
          staticClass: "mb-0",
          attrs: {
            "items": row.item.modules,
            "fields": _vm.moduleFields,
            "small": "",
            "bordered": ""
          },
          scopedSlots: _vm._u([{
            key: "amount",
            fn: function(data) {
              return [_vm._v("\n                        " + _vm._s(_vm.formatCurrency(data.value)) + "\n                      ")]
            }
          }])
        })], 1)])])]) : _vm._e()])]
      }
    }])
  }, [_c('template', {
    slot: "table-busy"
  }, [_c('div', {
    staticClass: "text-center text-danger my-2"
  }, [_c('b-spinner', {
    staticClass: "align-middle",
    attrs: {
      "small": ""
    }
  }), _vm._v(" "), _c('strong', {
    staticClass: "ml-2"
  }, [_vm._v("Loading...")])], 1)])], 2), _vm._v(" "), (_vm.totalItems > _vm.pagination.perPage) ? _c('b-pagination', {
    staticClass: "mt-3",
    attrs: {
      "limit": "25",
      "align": "center",
      "per-page": _vm.pagination.perPage,
      "total-rows": _vm.totalItems
    },
    on: {
      "change": _vm.onPageChange
    },
    model: {
      value: (_vm.pagination.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.pagination, "currentPage", $$v)
      },
      expression: "pagination.currentPage"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mt-2 d-flex justify-content-between align-items-center"
  }, [_c('div', [_c('b-form-select', {
    staticClass: "w-auto",
    attrs: {
      "options": _vm.pagination.pageOptions,
      "size": "sm"
    },
    on: {
      "change": _vm.updatePagination
    },
    model: {
      value: (_vm.pagination.perPage),
      callback: function($$v) {
        _vm.$set(_vm.pagination, "perPage", $$v)
      },
      expression: "pagination.perPage"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "ml-2 text-muted"
  }, [_vm._v("per page")])], 1), _vm._v(" "), _c('div', {
    staticClass: "text-muted small"
  }, [_vm._v("\n          Total Records: " + _vm._s(_vm.totalItems) + " | Total Amount: " + _vm._s(_vm.formatCurrency(_vm.totalExpenseAmount)) + "\n        ")])])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7eafff38","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/dashboard/salesPersonDashboard/ExpenseSection.vue
// module id = 2779
// module chunks = 0